import React from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  totalItems?: number;
  itemsPerPage?: number;
}
export function Pagination({
  currentPage,
  totalPages,
  onPageChange,
  totalItems,
  itemsPerPage = 6
}: PaginationProps) {
  if (totalPages <= 1) return null;
  const pages: (number | '...')[] = [];
  if (totalPages <= 7) {
    for (let i = 1; i <= totalPages; i++) pages.push(i);
  } else {
    pages.push(1);
    if (currentPage > 3) pages.push('...');
    for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 1, currentPage + 1); i++) {
      pages.push(i);
    }
    if (currentPage < totalPages - 2) pages.push('...');
    pages.push(totalPages);
  }
  const from = (currentPage - 1) * itemsPerPage + 1;
  const to = Math.min(currentPage * itemsPerPage, totalItems || currentPage * itemsPerPage);
  return <div className="flex items-center justify-between px-2 py-3" data-id="element-232">
      {totalItems !== undefined ? <p className="text-sm text-slate-500" data-id="element-233">
          Mostrando{' '}
          <span className="font-medium text-slate-700" data-id="element-234">
            {from}–{to}
          </span>{' '}
          de <span className="font-medium text-slate-700" data-id="element-235">{totalItems}</span>{' '}
          registros
        </p> : <div data-id="element-236" />}

      <div className="flex items-center gap-1" data-id="element-237">
        <button onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 1} className="p-2 rounded-lg text-slate-500 hover:bg-slate-100 disabled:opacity-30 disabled:cursor-not-allowed transition-colors" data-id="element-238">
          <ChevronLeftIcon className="w-4 h-4" data-id="element-239" />
        </button>

        {pages.map((page, idx) => page === '...' ? <span key={`ellipsis-${idx}`} className="px-2 text-slate-400 text-sm" data-id="element-240">
              …
            </span> : <button key={page} onClick={() => onPageChange(page as number)} className={`min-w-[32px] h-8 px-2 rounded-lg text-sm font-medium transition-colors ${currentPage === page ? 'text-white shadow-sm' : 'text-slate-600 hover:bg-slate-100'}`} style={currentPage === page ? {
        backgroundColor: '#2952C4'
      } : {}} data-id="element-241">
              {page}
            </button>)}

        <button onClick={() => onPageChange(currentPage + 1)} disabled={currentPage === totalPages} className="p-2 rounded-lg text-slate-500 hover:bg-slate-100 disabled:opacity-30 disabled:cursor-not-allowed transition-colors" data-id="element-242">
          <ChevronRightIcon className="w-4 h-4" data-id="element-243" />
        </button>
      </div>
    </div>;
}